<template>
  <div class="container-fluid p-0">
    <PageTitle
      :title="pageTitle"
      :titleSave="pendingAnalysis ? $t('management.salvar') : $t('management.salvar')"
      :isAdd="false"
      @onSave="save"
      @onCancel="cancel"
      @onExcluir="excluir"
      :nameEdit="nameEdit"
      :pendingAnalysis="pendingAnalysis"
      :hasExportCSV="this.$route.params.id !== this.$actionNew"
      @onExportCSV="exportCSV"
    />

    <div class="row">
      <div class="col-12 d-flex">
        <div class="card flex-fill">
          <div class="card-body box-dashboard p-3">
            <div class="align-self-center">
              <div class="row">
                <div class="col-md-6">
                  <div class="mt-3">
                    <label for="management-locality" class="form-label">{{ $t('localidade.pageTitle') }}</label>
                    <v-select
                      :appendToBody="true"
                      :filterable="false"
                      @search="getLocalities"
                      :options="localitiesList"
                      v-model="item.locality_id"
                      @input="onLocalityChange"
                      label="name"
                      index="locality_id"
                      :reduce="r => r.locality_id"
                      :clearable="false"
                      class="wf-select vue-select"
                      :class="{ 'is-invalid': $v.item.locality_id.$dirty && !$v.item.locality_id.required }"
                    >
                      <template v-slot:selected-option="option">
                        {{ `${option.name}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.name}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{ `${$t('message.noResultsFor')} ` }}<em>{{ search }}</em>.
                        </template>
                      </template>
                    </v-select>
                    <div class="invalid-feedback">
                      {{ $t('message.requiredField') }}
                    </div>
                  </div>
                  <div class="mt-3">
                    <label class="form-label">{{ $t('management.ocorrencias_manejadas') }}</label>
                    <v-select
                      :options="occurrencesList"
                      v-model="item.occurrences_managed"
                      :reduce="o => o.occurrence_id"
                      :getOptionKey="o => o.occurrence_id"
                      multiple
                      placeholder="Selecione as ocorrências"
                      class="wf-select vue-select"
                    >
                      <template #option="{ occurrence_id, date }">
                         {{ occurrence_id || '-' }} - {{ date }}
                      </template>
                      <template #selected-option="{ occurrence_id, date }">
                        {{ occurrence_id || '-' }} - {{ date }}
                      </template>
                    </v-select>
                  </div>
                  <div
                    class="mt-3"
                    :class="{ 'pending_analysis': pendingAnalysis && item.log_update && item.date !== item.log_update.date }"
                  >
                    <label for="management-date" class="form-label">{{ $t('management.date') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="management-date"
                      v-model="item.date"
                      v-mask="'##/##/####'"
                      :class="{ 'is-invalid': $v.item.date.$dirty && $v.item.date.$error }"
                    />
                    <div class="invalid-feedback">
                      {{ $t('message.requiredField') }}
                    </div>
                  </div>
                  <div class="mt-3">
                    <label for="add-ocorrencias-colaborador" class="form-label">{{ $t('label.colaborador') }}</label>
                    <button class="btn" type="button" @click="analysis($t('label.colaborador'), 'relContactsSelected')" data-bs-toggle="modal" data-bs-target="#modalAnalysis">
                      <i class="fa fa-search" aria-hidden="true"></i>
                    </button>
                    <v-select
                      :appendToBody="true"
                      :filterable="false"
                      @search="getContacts"
                      :options="contactsList"
                      v-model="item.contact_id"
                      label="surname"
                      index="contact_id"
                      :reduce="r => r.contact_id"
                      :clearable="false"
                      class="wf-select vue-select"
                      :class="{ 'is-invalid': $v.item.contact_id.$dirty && !$v.item.contact_id.required }"
                    >
                      <template v-slot:selected-option="option">
                        {{ `${option.surname}, ${option.name}` }}
                      </template>
                      <template v-slot:option="option">
                        {{ `${option.surname}, ${option.name}` }}
                      </template>
                      <template v-slot:no-options="{ search, searching }">
                        <template v-if="searching">
                          {{`${ $t('message.noResultsFor') } `}}<em>{{ search }}</em>.
                        </template>
                      </template>
                    </v-select>
                    <div class="invalid-feedback">
                      {{ $t('message.requiredField') }}
                    </div>
                  </div>
                  <div  class="mt-3"  :class="{ 'pending_analysis': pendingAnalysis && item.log_update && item.observer !== item.log_update.observer }">
                    <label for="management-observer" class="form-label">{{ $t('management.observer') }}</label>
                    <input
                      type="text"
                      class="form-control"
                      id="management-observer"
                      v-model="item.observer"
                      :class="{ 'is-invalid': $v.item.observer.$dirty && $v.item.observer.$error }"
                    />
                    <div class="invalid-feedback">
                      {{ $t('message.requiredField') }}
                    </div>
                  </div>
                  <div class="mt-3">
                    <label for="management-number_of_divers" class="form-label">{{ $t('management.number_of_divers') }}</label>
                    <input
                      type="number"
                      class="form-control"
                      id="management-number_of_divers"
                      v-model.number="item.number_of_divers"
                      />
                  </div>
                </div>
                <div class="col-md-6 border-start">
                  <div class="mt-3">
                    <label for="management-number_of_cylinders" class="form-label">{{ $t('management.number_of_cylinders') }}</label>
                    <input
                      type="number"
                      class="form-control"
                      id="management-number_of_cylinders"
                      v-model.number="item.number_of_cylinders"
                      />
                  </div>
                  <div class="mt-3">
                    <label for="management-number_of_colonies" class="form-label">{{ $t('management.number_of_colonies') }}</label>
                    <input
                      type="number"
                      class="form-control"
                      id="management-number_of_colonies"
                      v-model.number="item.number_of_colonies"
                      />
                  </div>
                  <div class="mt-3">
                    <label for="management-method" class="form-label">{{ $t('management.method') }}</label>
                    <div id="management-method">
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="method-manual"
                          value="Manual"
                          v-model="item.method"
                          :class="{ 'is-invalid': $v.item.method.$dirty && $v.item.method.$error }"
                        />
                        <label class="form-check-label" for="method-manual">
                          {{ $t('management.method_manual') }}
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="method-mecanizado"
                          value="Mecanizado"
                          v-model="item.method"
                          :class="{ 'is-invalid': $v.item.method.$dirty && $v.item.method.$error }"
                        />
                        <label class="form-check-label" for="method-mecanizado">
                          {{ $t('management.method_mecanizado') }}
                        </label>
                      </div>
                      <div class="form-check">
                        <input
                          class="form-check-input"
                          type="radio"
                          id="method-manual-mecanizado"
                          value="Manual e Mecanizado"
                          v-model="item.method"
                          :class="{ 'is-invalid': $v.item.method.$dirty && $v.item.method.$error }"
                        />
                        <label class="form-check-label" for="method-manual-mecanizado">
                          {{ $t('management.method_manual_mecanizado') }}
                        </label>
                      </div>
                    </div>
                  </div>
                  <div class="mt-3">
                    <label for="management-managed_mass_kg" class="form-label">{{ $t('management.managed_mass_kg') }}</label>
                    <input
                      type="number"
                      class="form-control"
                      id="management-managed_mass_kg"
                      v-model.number="item.managed_mass_kg"
                      />
                  </div>
                  <div class="mt-3">
                    <label for="management-observation" class="form-label">{{ $t('management.observation') }}</label>
                    <textarea
                      class="form-control"
                      id="management-observation"
                      rows="4"
                      v-model="item.observation"
                    ></textarea>
                  </div>
                </div>
                <div class="col-md-12">
                  <div class="mt-3"  style="position: relative;">
                    <div id="map" ref="mapContainer" style="height: 500px;"></div>
                    <div class="map-overlay-top">
                      {{ $t('management.cursor_observacao') }}
                    </div>
                    <label for="management-coords" class="form-label">{{ $t('management.managementCoords') }}</label>
                    <div class="mt-3">
                      <label class="form-label">Coordenadas (editáveis)</label>

                      <div class="coord-columns">
                        <div
                          v-for="(coord, index) in points"
                          :key="index"
                          class="d-flex align-items-center mb-2"
                        >
                          <span class="me-2" style="width: 25px;">{{ index + 1 }}.</span>
                          <input
                            type="text"
                            class="form-control me-2"
                            :value="coord.join(',')"
                            @input="editCoord(index, $event.target.value)"
                          />
                          <button class="btn btn-danger btn-sm" @click="removeCoord(index)">X</button>
                        </div>
                      </div>

                      <!-- Campo para nova coordenada -->
                      <div v-if="!showManualInput" class="d-flex align-items-center mt-3">
                        <span class="me-2" style="width: 25px;">+</span>
                        <input
                          type="text"
                          class="form-control me-2"
                          v-model="newCoordText"
                          placeholder="-27.2948854507978,-48.36649074410231"
                        />
                        <button class="btn btn-success btn-sm" @click="addNewCoord">Acrescentar</button>
                      </div>

                      <div v-if="coordError" class="text-danger mt-1">{{ coordError }}</div>
                    </div>
                    <div class="invalid-feedback">
                      {{ $t('message.requiredField') }}
                    </div>
                    <button class="btn btn-secondary mt-2" :disabled="points.length === 0" @click="undoLastPoint">{{ $t('management.undoLastPoint') }}</button>
                    <button
                      class="btn btn-primary mt-2 ml-2 float-end"
                      @click="handleCoordButton"
                    >
                      {{ coordButtonText }}
                    </button>
                    <div v-if="showManualInput" class="d-flex flex-column flex-grow-1">
                      <input
                        v-model="manualCoord"
                        type="text"
                        class="form-control mt-2"
                        placeholder="[[-27.28, -48.35], [-27.29, -48.36]]" />
                      <small class="text-muted">Latitude, Longitude</small>
                      <button class="btn btn-success mt-2 ml-2" @click="addManualCoordinate">{{ $t('management.confirmar') }}</button>
                      <span v-if="coordError" class="text-danger mt-2 ml-2">{{ coordError }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <AdminModalReview :form="item" :modalValues="modalValues" />
  </div>
</template>

<script>
import axios from 'axios'
import L from 'leaflet'
import 'leaflet/dist/leaflet.css'
import PageTitle from '@/components/shared/PageTitle'
import AdminModalReview from '@/components/admin/AdminModalReview'
import { required } from 'vuelidate/lib/validators'

export default {
  name: 'CoralsolManejosForm',
  components: {
    PageTitle,
    AdminModalReview
  },
  data () {
    return {
      pageTitle: `${this.$t('management.pageTitle')} > ${this.$t('label.adicionar')}`,
      nameEdit: '',
      action: this.$actionNew,
      item: {
        locality_id: null,
        management_coords: '',
        date: this.$options.filters.formatDate(new Date()),
        observer: '',
        number_of_divers: null,
        number_of_cylinders: null,
        number_of_colonies: '',
        method: '',
        managed_mass_kg: null,
        observation: '',
        contact_id: null,
        occurrences_managed: []
      },
      modalValues: {
        label: '',
        isList: false,
        oldValue: '',
        newValue: ''
      },
      localitiesList: [],
      contactsList: [],
      map: null,
      drawnItems: null,
      polyline: null,
      points: [],
      startMarker: null,
      endMarker: null,
      localityPolyline: null,
      showManualInput: false,
      manualCoord: '',
      coordError: '',
      occurrencesList: [],
      selectedOccurrences: [],
      newCoordText: ''
    }
  },
  validations: {
    item: {
      date: {
        required,
        validDate (value) {
          return /^\d{2}\/\d{2}\/\d{4}$/.test(value)
        }
      },
      observer: { required },
      method: { required },
      management_coords: { required },
      locality_id: { required },
      contact_id: { required }
    }
  },
  watch: {
    'item.contact_id' (newValue, oldValue) {
      if (oldValue === undefined) {
        this.getContacts()
      }
    }
  },
  computed: {
    pendingAnalysis () {
      return this.item.pending_analysis && this.$store.state.user.perfilUser === 'administrator'
    },
    coordButtonText () {
      if (this.showManualInput) {
        return this.$t('management.cancelar')
      } else if (this.points.length > 0) {
        return this.$t('management.apagarCoordenadas')
      } else {
        return this.$t('management.adicionarCoordenada')
      }
    }
  },
  methods: {
    modalValuesSimple (newValue, oldValue, label) {
      this.modalValues.label = label
      this.modalValues.isList = false
      this.modalValues.newValue = newValue
      this.modalValues.oldValue = oldValue
    },
    analysis (label, input) {
      let newValue = ''
      let oldValue = ''
      switch (input) {
        case 'date':
          newValue = this.item.date
          oldValue = this.item.log_update ? this.item.log_update.date : ''
          this.modalValuesSimple(newValue, oldValue, label)
          break
        case 'observer':
          newValue = this.item.observer
          oldValue = this.item.log_update ? this.item.log_update.observer : ''
          this.modalValuesSimple(newValue, oldValue, label)
          break
      }
    },
    async save () {
      this.$v.$touch()
      if (this.$v.item.$invalid) {
        return false
      }
      Object.keys(this.item).forEach(key => {
        if (this.item[key] === '' || this.item[key] === null) {
          this.item[key] = null
        }
      })

      if (Array.isArray(this.item.occurrences_managed)) {
        this.item.occurrences_managed = this.item.occurrences_managed.join(',')
      }

      if (this.action === this.$actionEdit) {
        await axios.put('/CoralsolManagement', this.item)
          .then(() => {
            this.$toasted.global.saved()
            this.cancel()
          })
      } else {
        await axios.post('/CoralsolManagement', this.item)
          .then(() => {
            this.$toasted.global.saved()
            this.cancel()
          })
      }
    },
    cancel () {
      if (this.$store.state.beforeRouter === 'AdminHome') {
        this.$router.replace('/admin')
      } else {
        this.$router.replace('/admin/coralsol/manejos')
      }
    },
    exportCSV () {
      const contato = this.contactsList.find(c => c.contact_id === this.item.contact_id)
      const localidade = this.localitiesList.find(l => l.locality_id === this.item.locality_id)

      const dados = {
        date: this.item.date,
        observer: this.item.observer,
        locality: localidade ? localidade.name : '',
        contact: contato ? `${contato.surname}, ${contato.name}` : '',
        number_of_divers: this.item.number_of_divers,
        number_of_cylinders: this.item.number_of_cylinders,
        number_of_colonies: this.item.number_of_colonies,
        method: this.item.method,
        managed_mass_kg: this.item.managed_mass_kg,
        observation: this.item.observation,
        management_coords: this.item.management_coords,
        occurrences_managed: this.item.occurrences_managed
      }

      const labels = {
        date: 'Data',
        observer: 'Observador',
        locality: 'Localidade',
        contact: 'Colaborador',
        number_of_divers: 'Nº de Mergulhadores',
        number_of_cylinders: 'Nº de Cilindros',
        number_of_colonies: 'Nº de Colônias',
        method: 'Método',
        managed_mass_kg: 'Massa Gerenciada (kg)',
        observation: 'Observações',
        management_coords: 'Coordenadas do Manejo',
        occurrences_managed: 'Ocorrências Manejadas'
      }

      const headers = Object.keys(dados).map(key => labels[key]).join(';')
      const values = Object.values(dados).map(value =>
        typeof value === 'string' ? `"${value.replace(/"/g, '""')}"` : value
      ).join(';')

      const csv = `${headers}\n${values}`

      const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.setAttribute('download', 'formulario_manejo.csv')
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
    },
    async excluir () {
      if (confirm(this.$t('message.confirmDel'))) {
        await axios.delete(`/CoralsolManagement/${this.item.management_id}`)
          .then(() => {
            this.$toasted.global.defaultSuccess()
            this.cancel()
          })
      }
    },
    getLocalities (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.name = search
        loading(true)
        axios.get('/CoralSolLocality/getallcombo', { params })
          .then(response => {
            this.localitiesList = response.data.items
            loading(false)
          })
      } else if (!search) {
        if (this.item.locality_id) {
          params.locality_id = this.item.locality_id
        }
        axios.get('/CoralSolLocality/getallcombo', { params })
          .then(response => {
            this.localitiesList = response.data.items
          })
      }
    },
    getContacts (search, loading) {
      const params = {
        Page: 1,
        PageSize: 9999
      }
      if (search && search.length > 2) {
        params.surname = search
        loading(true)
        axios.get('/Contact/getallcombo', { params })
          .then(response => {
            this.contactsList = response.data.items.filter((item, index, self) => index === self.findIndex((t) => t.contact_id === item.contact_id))
            loading(false)
          })
      } else if (!search) {
        params.contact_id = this.item.contact_id
        axios.get('/Contact/getallcombo', { params })
          .then(response => {
            this.contactsList = response.data.items.filter((item, index, self) => index === self.findIndex((t) => t.contact_id === item.contact_id))
          })
      }
    },
    async onLocalityChange (value) {
      if (value) {
        await this.focusLocality(value)
        const resp = await axios.get(`/CoralsolOccurrence/by-locality/${value}`)
        this.occurrencesList = resp.data.items.map(o => ({
          occurrence_id: o.occurrence_id,
          date: o.date,
          depth: o.depth,
          access: o.access,
          method: o.method,
          spot_coords: o.spot_Coords || o.spot_coords
        }))
        this.plotOccurrencesOnMap()
      }
    },
    async getById (id) {
      this.$store.dispatch('showPreload')
      const response = await axios.get(`/CoralsolManagement/${id}`)
      this.item = response.data
      await this.$nextTick()
      await this.initializeMap()

      if (this.item.locality_id) {
        this.getLocalities()
        this.focusLocality(this.item.locality_id)
        const resp = await axios.get(`/CoralsolOccurrence/by-locality/${this.item.locality_id}`)
        this.occurrencesList = resp.data.items.map(o => ({
          occurrence_id: o.occurrence_id,
          date: o.date,
          depth: o.depth,
          access: o.access,
          method: o.method,
          spot_coords: o.spot_Coords || o.spot_coords
        }))
        this.plotOccurrencesOnMap()

        if (this.item.occurrences_managed && typeof this.item.occurrences_managed === 'string') {
          this.item.occurrences_managed = this.item.occurrences_managed
            .split(',')
            .map(id => parseInt(id))
            .filter(Boolean)
        }
      }

      if (this.item.contact_id) {
        this.getContacts()
      }
    },
    initializeMap () {
      if (this.map) {
        return
      }

      this.map = L.map(this.$refs.mapContainer).setView([-27.2833, -48.3683], 13)

      L.tileLayer('https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}', {
        maxZoom: 18,
        attribution: 'Tiles © Esri'
      }).addTo(this.map)

      this.drawnItems = L.featureGroup().addTo(this.map)

      if (this.item.management_coords) {
        const coords = JSON.parse(this.item.management_coords)
        this.points = coords
        this.polyline = L.polyline(coords, { color: 'red' }).addTo(this.drawnItems)
        this.updateMarkers()
        const bounds = this.polyline.getBounds()
        this.map.fitBounds(bounds)
      } else {
        this.map.setView([-27.2833, -48.3683], 13)
      }

      this.map.on('click', this.onMapClick)
    },
    async focusLocality (localityId) {
      const locality = await axios.get(`/CoralSolLocality/${localityId}`)
      const coords = JSON.parse(locality.data.coords_local)
      if (this.localityPolyline) {
        this.drawnItems.removeLayer(this.localityPolyline)
      }
      this.localityPolyline = L.polyline(coords, { color: 'blue' }).addTo(this.drawnItems)
      this.map.fitBounds(this.localityPolyline.getBounds())
    },
    onMapClick (e) {
      const latlng = e.latlng
      this.points.push([latlng.lat, latlng.lng])
      this.polyline = L.polyline(this.points, { color: 'red' }).addTo(this.drawnItems)
      this.updateMarkers()
      this.item.management_coords = JSON.stringify(this.points)
    },
    updateMarkers () {
      if (this.startMarker) {
        this.drawnItems.removeLayer(this.startMarker)
      }
      if (this.endMarker) {
        this.drawnItems.removeLayer(this.endMarker)
      }

      if (this.points.length > 0) {
        this.startMarker = L.marker(this.points[0], {
          icon: L.icon({
            iconUrl: 'https://maps.google.com/mapfiles/ms/icons/green-dot.png',
            iconSize: [32, 32],
            iconAnchor: [16, 32]
          })
        }).addTo(this.drawnItems)
      }

      if (this.points.length > 1) {
        this.endMarker = L.marker(this.points[this.points.length - 1], {
          icon: L.icon({
            iconUrl: 'https://maps.google.com/mapfiles/ms/icons/red-dot.png',
            iconSize: [32, 32],
            iconAnchor: [16, 32]
          })
        }).addTo(this.drawnItems)
      }

      if (this.points.length > 0 && this.showManualInput) {
        this.showManualInput = false
      }
    },
    undoLastPoint () {
      this.points.pop()
      if (this.polyline) {
        this.drawnItems.removeLayer(this.polyline)
      }
      this.polyline = L.polyline(this.points, { color: 'red' }).addTo(this.drawnItems)
      this.updateMarkers()
      this.item.management_coords = JSON.stringify(this.points)
    },
    toggleManualInput () {
      this.showManualInput = !this.showManualInput
      this.manualCoord = ''
      this.coordError = ''
    },
    addManualCoordinate () {
      let parsed

      try {
        parsed = JSON.parse(this.manualCoord)

        const isValidFormat = Array.isArray(parsed) &&
          parsed.every(coord =>
            Array.isArray(coord) &&
            coord.length === 2 &&
            typeof coord[0] === 'number' &&
            typeof coord[1] === 'number' &&
            coord[0] >= -90 && coord[0] <= 90 &&
            coord[1] >= -180 && coord[1] <= 180
          )

        if (!isValidFormat) {
          throw new Error()
        }
      } catch (e) {
        this.coordError = 'Formato inválido. Use: [[lat, lng], [lat, lng], ...]'
        return
      }

      // Adiciona os pontos ao array principal
      this.points.push(...parsed)

      if (this.polyline) {
        this.drawnItems.removeLayer(this.polyline)
      }

      this.polyline = L.polyline(this.points, { color: 'red' }).addTo(this.drawnItems)
      this.updateMarkers()
      this.map.fitBounds(this.polyline.getBounds())
      this.item.management_coords = JSON.stringify(this.points)
      this.toggleManualInput()
    },
    handleCoordButton () {
      if (this.showManualInput) {
        this.toggleManualInput()
      } else if (this.points.length > 0) {
        this.removeAllCoordinates()
      } else {
        this.toggleManualInput()
      }
    },
    removeAllCoordinates () {
      this.points = []
      if (this.polyline) {
        this.drawnItems.removeLayer(this.polyline)
        this.polyline = null
      }
      this.updateMarkers()
      this.item.management_coords = ''
    },
    plotOccurrencesOnMap () {
      if (!this.map || !this.occurrencesList.length) return

      this.occurrencesList.forEach(o => {
        if (o.spot_coords) {
          try {
            const coords = JSON.parse(o.spot_coords)
            if (Array.isArray(coords) && coords.length) {
              const latlng = coords[0]
              console.log(o.depth)
              const popupContent = `
                <strong>ID:</strong> ${o.occurrence_id}<br>
                <strong>Data:</strong> ${o.date}<br>
                <strong>Acessibilidade:</strong> ${o.access || '-'}
                <div style="margin-top: 6px;">
                  <a href="/admin/coralsol/ocorrencias/${o.occurrence_id}" target="_blank" rel="noopener noreferrer" style="color: blue; text-decoration: underline;">
                     ${this.$t('management.ver_ocorrencia')}
                  </a>
                </div>
              `
              L.marker(latlng).bindPopup(popupContent).addTo(this.drawnItems)
            }
          } catch (e) {
            console.warn('Erro ao processar spot_coords da ocorrência', o)
          }
        }
      })
    },
    updateCoordsFromList () {
      // Atualiza o campo `management_coords` com base nos pontos editados
      this.item.management_coords = JSON.stringify(this.points)
      if (this.polyline) {
        this.drawnItems.removeLayer(this.polyline)
      }
      this.polyline = L.polyline(this.points, { color: 'red' }).addTo(this.drawnItems)
      this.updateMarkers()
    },
    editCoord (index, value) {
      const parts = value.split(',').map(p => parseFloat(p.trim()))
      if (parts.length === 2 && !isNaN(parts[0]) && !isNaN(parts[1])) {
        this.points[index] = parts
        this.updateCoordsFromList()
      } else {
        this.$toasted.error('Coordenada inválida.')
      }
    },
    addNewCoord () {
      const parts = this.newCoordText.split(',').map(p => parseFloat(p.trim()))

      if (
        parts.length === 2 &&
        !isNaN(parts[0]) &&
        !isNaN(parts[1]) &&
        parts[0] >= -90 && parts[0] <= 90 &&
        parts[1] >= -180 && parts[1] <= 180
      ) {
        this.points.push(parts)
        this.newCoordText = ''
        this.coordError = ''
        this.updateCoordsFromList()
        if (this.polyline) {
          this.map.fitBounds(this.polyline.getBounds())
        }
      } else {
        this.coordError = 'Formato inválido. Use: -27.29,-48.36'
      }
    },

    removeCoord (index) {
      this.points.splice(index, 1)
      this.updateCoordsFromList()
    }
  },
  created () {
    this.action =
      this.$route.params.id !== this.$actionNew
        ? this.$actionEdit
        : this.$actionNew

    if (this.action === this.$actionEdit) {
      this.pageTitle = `${this.$t('management.pageTitle')} > ${this.$t('label.editando')}:`
      this.getById(this.$route.params.id)
    } else {
      this.$nextTick(() => {
        this.initializeMap()
      })
    }
    this.getLocalities()
    this.getContacts()
  }
}
</script>

<style scoped>
#map {
  height: 500px;
}
.map-overlay-top {
  position: absolute;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  background: rgba(255, 255, 255, 0.8);
  padding: 6px 12px;
  border-radius: 4px;
  font-size: 14px;
  z-index: 1000;
  pointer-events: none;
}
.coord-columns {
  column-count: 2;
  column-gap: 2rem;
}

.coord-columns > div {
  break-inside: avoid;
}
</style>
